// API URL Configuration
// Handles both local development and production environments

export const getApiUrl = () => {
  // In browser environment
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    
    // For localhost/127.0.0.1 - use the external preview URL (goes through ingress)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Use the preview URL which has proper routing
      return 'https://elegance-hub-40.preview.emergentagent.com';
    }
    
    // For production - use current origin (works with any custom domain)
    return window.location.origin;
  }
  return '';
};

// Helper to resolve image URLs (handles both relative and absolute URLs)
export const resolveImageUrl = (url) => {
  if (!url) return null;
  // Already absolute URL - return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Relative API URL - prepend the API base URL
  if (url.startsWith('/api/')) return `${getApiUrl()}${url}`;
  // Other relative URLs
  return url;
};

// XMLHttpRequest-based request function to avoid "Body is disturbed" issues
export const makeRequest = (method, url, data = null, headers = {}, isFormData = false) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    
    // Set headers
    xhr.setRequestHeader('Accept', 'application/json');
    Object.keys(headers).forEach(key => {
      xhr.setRequestHeader(key, headers[key]);
    });
    
    // Only set Content-Type for JSON data, not FormData
    if (data && !isFormData) {
      xhr.setRequestHeader('Content-Type', 'application/json');
    }
    
    xhr.onload = function() {
      try {
        const response = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({ ok: true, status: xhr.status, data: response });
        } else {
          resolve({ ok: false, status: xhr.status, data: response });
        }
      } catch (e) {
        reject(new Error('Invalid JSON response'));
      }
    };
    
    xhr.onerror = function() {
      reject(new Error('Network error'));
    };
    
    if (isFormData) {
      xhr.send(data);
    } else {
      xhr.send(data ? JSON.stringify(data) : null);
    }
  });
};

// Export for compatibility  
export const API_URL = typeof window !== 'undefined' ? getApiUrl() : '';
